import { axiosInstance } from "../../../../Services";

export const fetchAllBoards = async () => {
  try {
    const res = await axiosInstance.get("/mmhboard/boards");
    return res;
  } catch (error) {
    throw error;
  }
};

export const fetchBoardDetails = async () => {
  try {
    const res = await axiosInstance.get("/mmhboard/boards");
    return res;
  } catch (error) {
    throw error;
  }
};

export const searchCards = async (boardId, filters = {}) => {
  try {
    let url = `/mmhboard/cards/search/?board_id=${boardId}`;
    const params = new URLSearchParams();

    // Build query params from filters
    for (const [key, value] of Object.entries(filters)) {
      if (value !== null && value !== undefined && value !== '') {
        if (Array.isArray(value)) {
          value.forEach(v => params.append(key, v));
        } else {
          params.append(key, value);
        }
      }
    }

    if (params.toString()) {
      url += `&${params.toString()}`;
    }

    const res = await axiosInstance.get(url);
    return res;
  } catch (error) {
    throw error;
  }
};

export const getCardDetails = async (cardId) => {
  try {
    const res = await axiosInstance.get(`/mmhboard/cards/${cardId}`);
    return res;
  } catch (error) {
    throw error;
  }
};

export const moveCard = async (cardId, newListId, newPosition) => {
  try {
    const res = await axiosInstance.put(
      `/mmhboard/cards/move/${cardId}`,
      { list_id: newListId, position: newPosition },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    return res;
  } catch (error) {
    throw error;
  }
};
